export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5531.4577b323.jpg";